import { render, staticRenderFns } from "./QuotationLineItemsCreateUpdate.vue?vue&type=template&id=5c4180e2"
import script from "./QuotationLineItemsCreateUpdate.vue?vue&type=script&lang=js"
export * from "./QuotationLineItemsCreateUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports